import { CommonPerm } from '@enum/common/permission/common-perm.enum';

/**
 * Seção GOVERNANÇA do central (dono, 21/09/2026): "Leituras de documento" saiu
 * de Histórico, que fica só com Ações. A rota continua a mesma.
 */
export const GovernanceSection = [
  {
    section: 'Governança',
    permission: ['*', CommonPerm.Logs_View],
  },
  {
    title: 'Leituras de documento',
    permission: ['*', CommonPerm.Logs_View],
    root: true,
    icon: 'fact_check',
    bullet: 'dot',
    page: '/admin/leituras-de-documento',
  },
];
